import React from 'react';
import InformationHeader from '../../../component/reusable/informationHeader/InformationHeader';
import AddCategoryForm from '../../../component/addCategoryForm/AddCategoryForm';
const AddCategory = () => {


  return (
    <div>
      <InformationHeader mainpage="Dashboard" prevpage="Categories"  pagename="Add Category" buttonText="Save"/>
      <AddCategoryForm/>
    </div>
  );
};

export default AddCategory;
